import * as Entities from "@/resources/Entities";
import {
  searchColumnHeaders as storeColumnHeaders,
  filterCriteria as storeFilterCriteria,
} from "../Store/inputs";

// OrganizationGroup Editor Inputs

// Page Header
export const pageHeader = {
  title: "MSO Group",
  isEditorView: true,
  cancelPath: "msoGroups",
  addPath: "msoGroupEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "MSO Groups",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "msoGroupEditor",
};

// MSOGroup Information - Main Section
export const msoGroupInfoInputs = [
  {
    id: "name",
    placeholder: "Group Name",
    type: "input",
    title: "Group Name",
    focus: true,
  },
  {
    id: "nameCode",
    placeholder: "Accounting Code",
    type: "input",
    title: "Accounting Code",
  },
  {
    id: "isCannabis",
    placeholder: "Cannabis",
    type: "checkBox",
    title: "Cannabis",
  },
  {
    id: "isActive",
    placeholder: "Active",
    type: "checkBox",
    title: "Active",
  },
  {
    id: "onlineStoreWeightUoM",
    placeholder: "g or mg",
    type: "select",
    title: "Online Store Weight Unit of Measure",
    options: [
      { label: "g", code: "g" },
      { label: "mg", code: "mg" },
    ],
  },
  {
    id: "notes",
    placeholder: "Notes",
    type: "textarea",
    title: "Notes",
    class: "grid-row-two-column",
  },
];


export const msoGroupIntegrationInputs = [
  {
    id: "weedmapsId",
    placeholder: "Weedmap Group Id",
    type: "input",
    title: "Weedmap Group Id",
  },
];

export const defaultSelectedMsoGroup = {
  _id: "NEW",
  name: "",
  nameCode: "",
  isCannabis: true,
  isActive: true,
  isDeleted: false,
  notes: "",
  verifiedBy: {},
  createdBy: {},
  updatedBy: {},
};

export const filterCriteria = [
  {
    label: "Name",
    code: "name",
    field: { type: "input", label: "name" },
    isPartial: true,
  },
  {
    label: "Accounting Code",
    code: "nameCode",
    numCharsToSearch: 1,
    field: { type: "input", label: "nameCode" },
    isPartial: true,
  },
  { label: "Id", code: "_id", field: { type: "input", label: "Id" } },
];

export const columnHeaders = [
  {
    id: "open",
    type: "button",
    action: "navigateToEntity",
    iconName: "folder-open",
    ariaLabel: "Open",
  },
  {
    title: "Cannabis",
    id: "isCannabis",
    type: "checkbox",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Online Store UoM",
    id: "onlineStoreWeightUoM",
    size: "large",
  },
  {
    title: "Accounting Code",
    id: "nameCode",
    size: "large",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Deleted",
    id: "isDeleted",
    type: "checkbox",
  },
  {
    title: "Name",
    id: "name",
  },
  {
    title: "Id",
    id: "_id",
  },
  {
    title: "Accounting Code",
    id: "nameCode",
  },
  {
    title: "Store",
    id: "store",
  },
];
